<div class="v4-layout-info" [formGroup]="form" [class.editing]="isEditing">
  <div class="v4-layout-info-title flex flex-row items-center justify-between">
    <span>{{ "order.check_in_info" | translate }}</span>

    <div>
      @if (!isEditing) {
        <a nz-button nzType="link" nzSize="small" (click)="onEdit.emit()">
          {{ "word.modify" | translate }}
        </a>
      } @else {
        <a nz-button nzType="link" nzSize="small" (click)="onCancelEdit.emit()">
          {{ "word.cancel" | translate }}
        </a>
        <a class="ml-2" nz-button nzType="link" nzSize="small" (click)="onModifyBasicInfo()">
          {{ "word.save" | translate }}
        </a>
      }
      <ng-template #editingTitleExtra> </ng-template>
    </div>
  </div>
  <div class="v4-layout-fields">
    <!-- 状态 -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <span>{{ "order.status" | translate }}</span>
      </div>

      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          @if (isPendingVerify) {
            <div [class]="['v4-tag', 'status', 'pending-status']">
              {{ "order_status.is_pending_verify" | translate }}
            </div>
          } @else {
            <div [class]="['v4-tag', 'status', orderDetail?.out_status]">
              {{ "order_status." + orderDetail?.out_status | translate }}
            </div>
          }
          <a
            *ngIf="['revoke_check_in', 'revoke_check_out'].indexOf(orderDetail?.handle_status) !== -1"
            nz-button
            nzType="link"
            nzSize="small"
            class="ml-2"
            (click)="onRevokeCheckStatus.emit()">
            <!-- 撤销入住、撤销退房 -->
            {{
              (orderDetail?.handle_status === "revoke_check_in" ? "order.cancel_check_in" : "order.cancel_check_out")
                | translate
            }}
          </a>
        </div>
      </div>
    </div>

    <!-- 入离 -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <span>
          {{ "order.check_in_and_out_date" | translate }}
        </span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          @if (!isEditing) {
            @if (isHourReservation) {
              {{ hourResvCheckinText }}
            } @else {
              {{ resvCheckinText }}
            }
          } @else {
            @if (isHourReservation) {
              <nz-date-picker class="flex-1" formControlName="date"></nz-date-picker>
            } @else {
              <nz-range-picker class="flex-1" [nzFormat]="angularDateFormat" formControlName="date"></nz-range-picker>
            }
          }
        </div>
      </div>
    </div>

    <!-- 来源 -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <span>{{ "order.origin" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          @if (!isEditing) {
            <!-- 换房 -->
            <span class="whitespace-nowrap" *ngIf="orderDetail?.has_changed"
              >{{ "order_detail-house_basic_html_换房单" | translate }}-</span
            >

            @if (isDirectBooking) {
              <!-- 手工单 -->
              <span class="whitespace-nowrap">
                {{ "order.handmade_order" | translate }}
                - {{ orderDetail?.channel?.channel_name }}
              </span>
            } @else {
              <!-- 渠道单 -->
              {{ "word.channel_" + orderDetail?.thirdparty_type | translate }}
            }
          } @else {
            @if (isDirectBooking) {
              <nz-select
                class="flex-1"
                formControlName="channel"
                [nzOptions]="optionsOfManualChannel"
                [nzDropdownMatchSelectWidth]="false">
              </nz-select>
            } @else {
              {{ "word.channel_" + orderDetail?.thirdparty_type | translate }}
            }
          }
        </div>
      </div>
    </div>

    <!-- 初始房间 -->
    <div class="v4-layout-field" *ngIf="orderDetail?.has_changed">
      <div class="v4-layout-field-label">
        <span>{{ "order.origin_house" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <span [attr.title]="orderDetail?.old_house">
            {{ orderDetail?.old_house | ellipsis: 20 }}
          </span>
        </div>
      </div>
    </div>

    <!-- 房客 -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <span>{{ "order.tenant" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          @if (!isEditing) {
            <div class="ellipsis" nz-popover [nzPopoverTitle]="null" [nzPopoverContent]="clientItem">
              <ng-template
                [ngTemplateOutlet]="clientItem"
                [ngTemplateOutletContext]="{ $implicit: true }"></ng-template>

              <ng-template #clientItem let-simple>
                <img src="/assets/v4/icon-guest.svg" class="w-[16px]" alt="" />
                <span
                  class="align-middle"
                  [ngClass]="{
                    'text-c-d2': !simple
                  }">
                  <span>{{ orderDetail?.number_of_guests || "1" }}</span>
                  <span *ngIf="!simple && guestDetailInfo"> {{ guestDetailInfo }}</span>
                  <span *ngIf="simple"> - {{ orderDetail?.client?.name }} </span>
                </span>
              </ng-template>
            </div>
            @if (orderDetail?.thread_id) {
              <button nz-button nzSize="small" class="ml-2 no-min-width" (click)="toInboxPage()">
                {{ "order.chat" | translate }}
              </button>
            }
            <button nz-button nzSize="small" class="ml-2 no-min-width" (click)="onClickGuestDetail.emit()">
              {{ "word.detail" | translate }}
            </button>
          } @else {
            <input
              class="flex-1 w-1/3"
              nz-input
              formControlName="name"
              placeholder="{{ 'order.tenant_name' | translate }}" />

            <v4-guest-select class="flex-2 w-2/3 ml-2" formControlName="guests"></v4-guest-select>
          }
        </div>
      </div>
    </div>

    <!-- 邮箱 -->
    <div class="v4-layout-field" *ngIf="displayEmail">
      <div class="v4-layout-field-label">
        <span>{{ "order.email" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <span class="w-full">{{ orderDetail?.client?.email }}</span>
        </div>
      </div>
    </div>

    <!-- 手机 -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <span>{{ "order.phone" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <!--        <div *ngIf="displayVirtualNumber" class="v4-layout-field-row whitespace-nowrap">-->
        <!--          <span>{{ displayVirtualNumber }}（虚拟号码） </span>-->
        <!--          <button nz-button nzSize="small" hostClipboard [clipboardData]="displayVirtualNumber">复制</button>-->
        <!--        </div>-->
        <div class="v4-layout-field-row">
          @if (!isEditing) {
            <span class="ellipsis">
              @if (form.get("mobile")?.value) {
                {{ orderDetail?.client?.phone }}
              } @else {
                {{ "order.no_mobile" | translate }}
              }
            </span>
            <button
              class="ml-2 no-min-width"
              nz-button
              nzSize="small"
              *ngIf="displayVirtualNumber"
              (click)="onRequestVirtualNumber()">
              申请虚拟号码
            </button>
            <button
              *ngIf="orderDetail?.client?.phone"
              class="ml-2 no-min-width"
              nz-button
              nzSize="small"
              hostClipboard
              [clipboardData]="orderDetail?.client?.phone">
              {{ "word.copy" | translate }}
            </button>
          } @else {
            @if (isInternational) {
              <div class="mr-[8px]">
                <nz-select
                  #codeSearch
                  class="w-[90px]"
                  nzShowSearch
                  [(ngModel)]="countryCode"
                  (nzBlur)="onSearchBlur(codeSearch)"
                  [ngModelOptions]="{ standalone: true }"
                  [nzOptions]="listOfCountryCode"
                  [nzDropdownMatchSelectWidth]="false">
                </nz-select>
              </div>
            }
            <input
              nz-input
              class="flex-1"
              type="number"
              formControlName="mobile"
              maxlength="13"
              placeholder="{{ 'placeholder.mobile_optional' | translate }}" />
          }
        </div>
      </div>
    </div>

    <!-- 附言 -->
    <div class="v4-layout-field" *ngIf="displayRemark">
      <div class="v4-layout-field-label">
        <span>{{ "order.remark" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row !w-[280px]" [class.!items-end]="generalRemarkUnfold">
          <span
            class="break-all"
            [class.ellipsis-line-2]="!generalRemarkUnfold"
            [innerHTML]="orderDetail?.remark?.replaceAll('\n', '<br>')"></span>
          <button
            nz-button
            nzSize="small"
            class="no-min-width ml-1"
            (click)="generalRemarkUnfold = !generalRemarkUnfold">
            {{ (generalRemarkUnfold ? "word.less" : "word.more") | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- 评价 -->
    <div class="v4-layout-field" *ngIf="orderDetail?.comment">
      <div class="v4-layout-field-label">
        <span>{{ "rate.word.rate" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <span class="ellipsis">{{ orderDetail?.comment?.guest_comment_desc }}</span>
          <button class="ml-2 no-min-width" nz-button nzSize="small" (click)="toRateDetail()">
            {{ "order.detail" | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- 入住号 -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <span>
          {{ "order.check_in_order_code" | translate }}
        </span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <div class="ellipsis">
            {{ orderDetail?.code }}
          </div>
          <button class="ml-2 no-min-width" nz-button nzSize="small" hostClipboard [clipboardData]="orderDetail?.code">
            <!-- 复制 -->
            {{ "word.copy" | translate }}
          </button>
          <button
            class="ml-2 no-min-width"
            nz-button
            nzSize="small"
            (click)="toLogPage('reservation', orderDetail?.code)">
            <!-- 日志 -->
            {{ "system.log" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #virtualNumberForm>
  <div class="v4-layout-form-vertical v4-layout-form">
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">请填写本机号码，作为主叫号码</div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <input [(ngModel)]="virtualNumber" type="text" nz-input nzSize="large" placeholder="主叫号码" />
        </div>
      </div>
    </div>
  </div>
</ng-template>
